/* DZ COD Theme — global scripts */
(function () {
  'use strict';

  /* ---------- Sticky CTA body padding ---------- */
  if (document.querySelector('.sticky-cta')) {
    document.body.classList.add('has-sticky-cta');
  }

  /* ---------- Menu drawer ---------- */
  var drawer = document.getElementById('MenuDrawer');
  var openBtn = document.getElementById('MenuOpen');
  if (drawer && openBtn) {
    var closeDrawer = function () { drawer.classList.remove('is-open'); };
    openBtn.addEventListener('click', function () { drawer.classList.add('is-open'); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ---------- Search toggle ---------- */
  var searchBar = document.getElementById('HeaderSearch');
  var searchBtn = document.getElementById('SearchToggle');
  if (searchBar && searchBtn) {
    searchBtn.addEventListener('click', function () {
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Product gallery ---------- */
  var mainImage = document.getElementById('GalleryMainImage');
  if (mainImage) {
    /* preload every full-size gallery image after page load so that
       switching images is instant instead of waiting for a download */
    var preloadGallery = function () {
      document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        var img = new Image();
        var srcset = thumb.getAttribute('data-srcset');
        if (srcset) {
          img.sizes = mainImage.getAttribute('sizes') || '100vw';
          img.srcset = srcset;
        }
        img.src = full;
      });
    };
    if (document.readyState === 'complete') {
      setTimeout(preloadGallery, 200);
    } else {
      window.addEventListener('load', function () { setTimeout(preloadGallery, 200); });
    }

    document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (!src) return;
        mainImage.src = src;
        if (thumb.getAttribute('data-srcset')) {
          mainImage.srcset = thumb.getAttribute('data-srcset');
        } else {
          mainImage.removeAttribute('srcset');
        }
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Sticky top bar ---------- */
  var stickyBar = document.getElementById('StickyProductBar');
  if (stickyBar) {
    var trigger = document.querySelector('.product-info__title') || document.body;
    window.addEventListener('scroll', function () {
      var passed = trigger.getBoundingClientRect().bottom < 0;
      stickyBar.classList.toggle('is-visible', passed);
    }, { passive: true });
  }

  /* ---------- COD form ---------- */
  var codForm = document.getElementById('CodForm');
  if (codForm) {
    var currencyLabel = codForm.getAttribute('data-currency-label') || 'دج';
    var qtyInput = codForm.querySelector('[name="quantity"]');
    var errorBox = codForm.querySelector('.cod-form__error');

    var formatMoney = function (cents) {
      return Math.round(cents / 100) + ' ' + currencyLabel;
    };

    var currentVariantId = function () {
      var checked = codForm.querySelector('[name="variant-id"]:checked');
      if (checked) return checked.value;
      return codForm.getAttribute('data-default-variant');
    };

    var unitPrice = function () {
      var checked = codForm.querySelector('[name="variant-id"]:checked');
      if (checked) return parseInt(checked.getAttribute('data-price'), 10) || 0;
      return parseInt(codForm.getAttribute('data-default-price'), 10) || 0;
    };

    var deliveryPrice = function () {
      var checked = codForm.querySelector('[name="delivery-method"]:checked');
      return checked ? parseInt(checked.getAttribute('data-price'), 10) || 0 : 0;
    };

    var deliveryLabel = function () {
      var checked = codForm.querySelector('[name="delivery-method"]:checked');
      return checked ? checked.value : '';
    };

    var updateSummary = function () {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var productTotal = unitPrice() * qty;
      var delivery = deliveryPrice();
      var elProduct = codForm.querySelector('[data-summary-product]');
      var elDelivery = codForm.querySelector('[data-summary-delivery]');
      var elTotal = codForm.querySelector('[data-summary-total]');
      if (elProduct) elProduct.textContent = formatMoney(productTotal);
      if (elDelivery) elDelivery.textContent = delivery > 0 ? formatMoney(delivery) : elDelivery.getAttribute('data-free-label');
      if (elTotal) elTotal.textContent = formatMoney(productTotal + delivery);
    };

    /* quantity +/- */
    codForm.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = val;
        updateSummary();
      });
    });

    codForm.addEventListener('change', updateSummary);
    qtyInput.addEventListener('input', updateSummary);
    updateSummary();

    /* submit: add to cart with properties, set attributes, go to checkout */
    codForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorBox) errorBox.classList.remove('is-visible');

      var name = codForm.querySelector('[name="customer-name"]').value.trim();
      var phone = codForm.querySelector('[name="customer-phone"]').value.trim();
      var wilaya = codForm.querySelector('[name="customer-wilaya"]').value;
      var communeField = codForm.querySelector('[name="customer-commune"]');
      var commune = communeField ? communeField.value.trim() : '';

      if (!name || !phone || !wilaya) {
        if (errorBox) {
          errorBox.textContent = errorBox.getAttribute('data-msg-required');
          errorBox.classList.add('is-visible');
        }
        return;
      }
      if (!/^(0)(5|6|7)[0-9]{8}$/.test(phone.replace(/\s/g, ''))) {
        if (errorBox) {
          errorBox.textContent = errorBox.getAttribute('data-msg-phone');
          errorBox.classList.add('is-visible');
        }
        return;
      }

      var submitBtn = codForm.querySelector('[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.setAttribute('data-original-text', submitBtn.textContent);
      submitBtn.textContent = submitBtn.getAttribute('data-loading-text') || '...';

      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

      var showError = function () {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-original-text');
        if (errorBox) {
          errorBox.textContent = errorBox.getAttribute('data-msg-error');
          errorBox.classList.add('is-visible');
        }
      };

      /* وضع التطبيق: إرسال الطلب مباشرة إلى App Proxy الخاص بتطبيق COD */
      if (codForm.getAttribute('data-order-mode') === 'app') {
        var endpoint = codForm.getAttribute('data-endpoint') || '/apps/cod/order';
        var payload = {
          variant_id: currentVariantId(),
          quantity: qty,
          customer_name: name,
          customer_phone: phone,
          wilaya: wilaya,
          commune: commune,
          delivery_method: deliveryLabel(),
          delivery_price: deliveryPrice(),
          product_total: unitPrice() * qty,
          total: unitPrice() * qty + deliveryPrice(),
          product_title: codForm.getAttribute('data-product-title'),
          product_url: codForm.getAttribute('data-product-url')
        };
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('app-failed');
            return res.json().catch(function () { return {}; });
          })
          .then(function (data) {
            window.location.href = data.redirect_url || codForm.getAttribute('data-thankyou') || '/pages/thank-you';
          })
          .catch(showError);
        return;
      }

      var properties = {};
      properties[codForm.getAttribute('data-label-name')] = name;
      properties[codForm.getAttribute('data-label-phone')] = phone;
      properties[codForm.getAttribute('data-label-wilaya')] = wilaya;
      if (commune) properties[codForm.getAttribute('data-label-commune')] = commune;
      if (deliveryLabel()) properties[codForm.getAttribute('data-label-delivery')] = deliveryLabel();

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: currentVariantId(), quantity: qty, properties: properties })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add-failed');
          var attributes = {};
          Object.keys(properties).forEach(function (k) { attributes[k] = properties[k]; });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attributes, note: name + ' — ' + phone + ' — ' + wilaya + (commune ? ' — ' + commune : '') })
          });
        })
        .then(function () {
          var parts = name.split(/\s+/);
          var q = new URLSearchParams();
          q.set('checkout[shipping_address][first_name]', parts[0]);
          q.set('checkout[shipping_address][last_name]', parts.slice(1).join(' ') || parts[0]);
          q.set('checkout[shipping_address][phone]', phone);
          q.set('checkout[shipping_address][address1]', commune || wilaya);
          q.set('checkout[shipping_address][city]', wilaya);
          window.location.href = '/checkout?' + q.toString();
        })
        .catch(showError);
    });
  }
})();
